import { ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, Output, ViewChild, OnInit, AfterViewInit } from '@angular/core';

@Component({
  selector: 'app-custom-video',
  templateUrl: './custom-video.component.html',
  styleUrls: ['./custom-video.component.scss']
})
export class CustomVideoComponent implements OnInit, AfterViewInit {
  @ViewChild('myVideo') videoPlayer!: ElementRef<HTMLVideoElement>;
  @ViewChild('progress-bar') progressBar!: ElementRef<HTMLInputElement>;
  play: any;
  isMediaLoading: boolean = true;
  @Output() toggleSwipe = new EventEmitter<boolean>();
  playedPercent!: number;
  isSeeking!: boolean;
  duration!: number;

  constructor(private readonly cdr: ChangeDetectorRef, private readonly el: ElementRef) { }
  isPlaying: boolean = false;
  isMuted: boolean = false;
  currentTime: number = 0;
  videoDuration: number = 0;
  volume: number = 1; // 0 to 1
  animationFrameId: any;
  @Input() sourceUrl !: any;
  bufferedPercent = 0;
  @Input() thumbnail_url!: string;
  @Output() videoLoaded = new EventEmitter<void>();


  ngOnInit() {
    const progressBarContainer = this.el.nativeElement.querySelector('.custom-controls');
    progressBarContainer.addEventListener('touchstart', this.stopPropagation, { passive: false });
    progressBarContainer.addEventListener('touchmove', this.stopPropagation, { passive: false });
    progressBarContainer.addEventListener('touchend', this.stopPropagation, { passive: false });
  }

  startProgressSync() {
    const sync = () => {
      const video = this.videoPlayer.nativeElement;
      this.currentTime = video.currentTime;
      this.cdr.markForCheck();
      this.animationFrameId = requestAnimationFrame(sync);
    };
    this.animationFrameId = requestAnimationFrame(sync);
  }

  ngAfterViewInit() {
    // Set initial volume
    this.videoPlayer.nativeElement.volume = this.volume;
    this.startProgressSync();

    // Listen for play/pause events to update isPlaying automatically
    const video = this.videoPlayer.nativeElement;
    video.addEventListener('play', () => {
      this.isPlaying = true;
      this.cdr.markForCheck();
    });
    video.addEventListener('pause', () => {
      this.isPlaying = false;
      this.cdr.markForCheck();
    });
  }

  togglePlayPause() {
    const video = this.videoPlayer.nativeElement;
    if (video.paused) {
      video.play();
    } else {
      video.pause();
    }
  }

  toggleMute() {
    this.isMuted = !this.isMuted;
    this.videoPlayer.nativeElement.muted = this.isMuted;
    // If unmuting and volume was 0, set to 0.5 as a default
    if (!this.isMuted && this.volume === 0) {
      this.volume = 0.5;
      this.videoPlayer.nativeElement.volume = this.volume;
    }
  }

  formatTime(time: number): string {
    const minutes = Math.floor(time / 60);
    const seconds = Math.floor(time % 60);
    return `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
  }


  seekVideo(event: any) {
    const video = this.videoPlayer.nativeElement;
    video.currentTime = event.target.value;
  }

  getProgressBarBackground(): string {
    const playedPercent = (this.currentTime / this.videoDuration) * 100;
    const buffered = this.bufferedPercent;

    return `linear-gradient(to right,
    #0078d6 0%,
    #0078d6 ${playedPercent}%,
      white ${playedPercent}%,
      white ${buffered}%,
      gray ${buffered}%,
      gray 100%)`;
  }


  getPlayButtonIconImage(): string {
    if (this.isPlaying) return "bds/pause/16";
    else return "media-play/24"
  }

  getMuteButtonIconImage(): string {
    if (this.isMuted) return "bds/volume-off/24";
    else return "bds/volume-up/24";
  }

  //  this method is for resetting the playbutton to initial state after previous and next is clicked
  resetPlayButton() {
    this.isPlaying = false;
    this.isMuted = false
  }

  onLoad() {
    this.isMediaLoading = false;
    this.videoLoaded.emit();
  }

  onError() {
    this.isMediaLoading = false;
  }

  onLoadedMetadata() {
    const video = this.videoPlayer.nativeElement;
    this.videoDuration = video.duration;
    this.updateBuffered();
    this.onLoad();
  }

  onTimeUpdate() {
    const video = this.videoPlayer.nativeElement;
    this.currentTime = video.currentTime;
    this.playedPercent = (this.currentTime / this.videoDuration) * 100;
    this.updateBuffered();
  }

  updateBuffered() {
    const video = this.videoPlayer.nativeElement;
     this.duration = video.duration;
    if (!this.duration || video.buffered.length === 0) return;

    let buffered = 0;
    for (let i = 0; i < video.buffered.length; i++) {
      if (
        video.buffered.start(i) <= video.currentTime &&
        video.buffered.end(i) > video.currentTime
      ) {
        buffered = video.buffered.end(i);
        break;
      }
    }
    this.bufferedPercent = (buffered / this.duration) * 100;
  }

  onSeekStart(event: MouseEvent) {
    this.isSeeking = true;
    this.seekTo(event);
  }

  onSeekMove(event: MouseEvent) {
    if (this.isSeeking) {
      this.seekTo(event);
    }
  }

  onSeekEnd(event: MouseEvent) {
    if (this.isSeeking) {
      this.seekTo(event);
      this.isSeeking = false;
    }
  }

  seekTo(event: MouseEvent) {
    const container = (event.currentTarget as HTMLElement).getBoundingClientRect();
    const clickX = event.clientX - container.left;
    const percentage = clickX / container.width;
    const video = this.videoPlayer.nativeElement;
    const newTime = percentage * video.duration;
    video.currentTime = newTime;
    this.currentTime = newTime;
    this.playedPercent = percentage * 100;
  }

  stopPropagation(event: TouchEvent): void {
    event.stopPropagation();
  }

}
